export default "__VITE_ASSET__BOOIJ0bv__"